<div
  class="file-explorer-root"
  (drop)="onRootDrop($event)"
  (dragover)="onRootDragOver($event)"
  [class.file-explorer-root-droppable]="draggableItems"
>
  <ul>
    <li
      *ngFor="let item of items"
      (drop)="onItemDrop(item, $event)"
      [draggable]="draggableItems && !root"
      (dragstart)="onItemDragged(item, $event)"
      (dragover)="onDragOver($event)"
      (dragenter)="onDragEnter($event)"
      (dragleave)="onDragLeave($event)"
    >
      <!-- for folders -->
      <div
        *ngIf="item.type === 'folder'"
        (click)="onItemClick(item)"
        class="file-explorer-content-container"
        (mouseenter)="hoveredItem = item"
        (mouseleave)="hoveredItem = null"
      >
        <div
          class="file-explorer-content-icon-wrapper"
          [style.min-height]="'16px'"
        >
          <i *ngIf="!item?.expanded" class="fa-regular fa-folder"></i>
          <i *ngIf="item?.expanded" class="fa-regular fa-folder-open"></i>
        </div>
        <span
          class="file-explorer-content-name"
          [ngClass]="{
            'file-explorer-content-name-selected':
              selected && selected === item?.id
          }"
        >
          {{ item.name }}
        </span>
        <span
          [style.min-width]="'14px'"
          *ngIf="draggableItems && !item.avoidDrag"
        >
          <i *ngIf="hoveredItem === item" class="fa-solid fa-grip-lines"></i>
        </span>
        <span
          *ngIf="showEditIcon && !item.avoidEdit"
          [style.min-width]="'14px'"
          (click)="handleEdit(item, $event)"
          ><i *ngIf="hoveredItem === item" class="fa-thin fa-pencil"></i
        ></span>

        <span
          [style.min-width]="'14px'"
          (click)="handleDelete(item, $event)"
          *ngIf="deleteableItems && !item.avoidDelete"
        >
          <i *ngIf="hoveredItem === item" class="fa-thin fa-trash-alt"></i>
        </span>
      </div>
      <!-- for the children of folders -->
      <ul *ngIf="item.type === 'folder' && item.children && item.expanded">
        <app-file-explorer
          (itemDelete)="handleDelete($event)"
          (editClicked)="handleEdit($event)"
          [deleteableItems]="deleteableItems"
          [showEditIcon]="showEditIcon"
          (itemDropped)="handleItemDrop($event)"
          [root]="false"
          [draggableItems]="draggableItems"
          [selected]="selected"
          [items]="item.children"
          (itemClicked)="itemClicked.emit($event)"
        ></app-file-explorer>
      </ul>
      <!-- for anything that isnt folders aka files -->
      <span
        class="file-explorer-content-container"
        *ngIf="item.type !== 'folder'"
        (click)="onItemClick(item)"
        (mouseenter)="hoveredItem = item"
        (mouseleave)="hoveredItem = null"
      >
        <ng-container [ngSwitch]="item?.type">
          <div
            class="file-explorer-content-icon-wrapper"
            class="file-explorer-file"
          >
            <i *ngSwitchCase="'workbook'" class="fa-regular fa-notebook"></i>

            <i *ngSwitchDefault class="fa-regular fa-file-code"></i>
          </div>
        </ng-container>
        <span
          [pTooltip]="item.name"
          pTooltipShowDelay="1000"
          class="file-explorer-content-name"
          [ngClass]="{
            'file-explorer-content-name-selected':
              selected && selected === item?.id
          }"
        >
          {{ item.name }}
        </span>
        <span
          [style.min-width]="'14px'"
          *ngIf="draggableItems && !item.avoidDrag"
        >
          <i *ngIf="hoveredItem === item" class="fa-solid fa-grip-lines"></i>
        </span>
        <span
          *ngIf="showEditIcon && !item.avoidEdit"
          [style.min-width]="'14px'"
          (click)="handleEdit(item, $event)"
          ><i *ngIf="hoveredItem === item" class="fa-thin fa-pencil"></i
        ></span>

        <span
          *ngIf="deleteableItems && !item.avoidDelete"
          [style.min-width]="'14px'"
          (click)="handleDelete(item, $event)"
        >
          <i *ngIf="hoveredItem === item" class="fa-thin fa-trash-alt"></i>
        </span>
      </span>
    </li>
  </ul>
  <div [style.padding-bottom]="root ? '60px' : '0px'"></div>
</div>
